import { createSlice } from "@reduxjs/toolkit";

export interface IState {


  error: any,
};

export const initialState: IState = {


  error: {},
};

const StatisticSlice = createSlice({
  name: "Statistic",
  initialState,
  reducers: {
    changeStatusBlockIPAction(state: any, action: any) {
      state.ipStatistics = action.payload;
    },
    changeStatusBlockUUIDAction(state: any, action: any) {
      state.uuidStatistics = action.payload;
    },
  },
  extraReducers: (builder) => {

  }
});

export const {
  changeStatusBlockIPAction, changeStatusBlockUUIDAction
} = StatisticSlice.actions;

export default StatisticSlice.reducer;